export default __webpack_public_path__ + "static/media/pannocchiaTtsIt_It60.faac8b31.mp3";